import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlComponent } from '../base-control.component';

@Component({
  selector: 'boi-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TimePickerComponent,
      multi: true
    }
  ],
  exportAs: 'boi-time-picker'
})
export class TimePickerComponent extends BaseControlComponent {
  @Input() public min: Date;
  @Input() public max: Date;
  @Input() public format: string;
  @Input() public placeholder: string;
  @Input() public isTooltipLast = true;
}
